import React from "react";
import ReactDOM from "react-dom";
import RSP from "./rsp";
import "./index.css";

ReactDOM.render(<RSP />, document.getElementById("root"));
